import { Button } from '@material-ui/core';
import { EmptyState } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { BROKER_TYPE, routes } from '../../lib/viva';
import { EntityArgoAppsCell } from './cells';
import { datastoreColumns } from './columns';
import { TypedCatalogPage } from './TypedCatalogPage';

const columns = datastoreColumns<CatalogTableRow>('Брокер', row => (
  <EntityArgoAppsCell entity={row.entity} />
));

export const BrokersPage = () => (
  <TypedCatalogPage
    section="brokers"
    title="Kafka"
    subtitle="Kafka в кластерах платформы: оператор Strimzi, состояние в ArgoCD"
    kind="resource"
    type={BROKER_TYPE}
    columns={columns}
    create={{ title: 'Создать кластер Kafka', to: routes.newKafka }}
    support="Брокер создаётся шаблоном «Кластер Kafka»: values попадают в viva/gitops (datastores/<кластер>/…), ArgoCD выбранного кластера разворачивает его, метрики уходят в Prometheus, дашборды — в Grafana."
    emptyContent={
      <EmptyState
        missing="data"
        title="Кластеров Kafka пока нет"
        description="Создайте Kafka из шаблона — оператор в кластере поднимет его, а запись появится здесь после регистрации в каталоге."
        action={
          <Button variant="contained" color="primary" href={routes.newKafka}>
            Создать кластер Kafka
          </Button>
        }
      />
    }
  />
);
